/*
Duplicate file server/booking-statuses.js
*/
export default {
  confirmed: {
    name: 'Confirmed',
    settingsName: 'Confirmed (automatically accepted)',
    status: 'confirmed',
  },
  pencilledIn: {
    name: 'Pencilled-in',
    settingsName: 'Pencilled-in (these can be accepted or declined)',
    status: 'pencilledIn',
  },
};
